module.exports = __webpack_public_path__ + "static/media/carlsjr.2713ab2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/carlsjr.png
// module id = 266
// module chunks = 0